import { useAuthenticator } from "@aws-amplify/ui-react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { getDairyAnswerDataById } from "../utility/getDairyAnswerData";
import { getDateForView } from "../utility/getFormattedDate";
import {
  postDairyAnswerDataType,
  preDairyAnswerDataType,
} from "../utility/putDairyAnswerData";
import { useAuth } from "../../context/AuthContext";

interface AnswerCheckDialogProps {
  isOn: boolean;
  setIsOn: React.Dispatch<React.SetStateAction<boolean>>;
  date?: string;
}

type affectValueType = {
  pleasantness: number;
  arousal: number;
};

export const AnswerCheckDialog: React.FC<AnswerCheckDialogProps> = ({
  isOn,
  setIsOn,
  date,
}) => {
  const { user } = useAuthenticator((context) => [context.user]);
  const { idToken, refreshAuthSession } = useAuth();
  const [preAnswer, setPreAnswer] = useState<preDairyAnswerDataType | null>(
    null
  );
  const [postAnswer, setPostAnswer] = useState<postDairyAnswerDataType | null>(
    null
  );

  useEffect(() => {
    if (idToken) {
      getDairyAnswerDataById(user.userId, idToken).then((data) => {
        if (date) {
          const pre = data.find((item: any) => item.date === `${date}-pre`);
          if (pre) {
            console.log(pre.answer);
            setPreAnswer(pre.answer);
          }
          const post = data.find((item: any) => item.date === `${date}-post`);
          if (post) {
            setPostAnswer(post.answer);
          }
        }
      });
    }
  }, []);

  const preDataView = (answerData: preDairyAnswerDataType | null) => {
    if (!answerData) return <Typography>未回答</Typography>;
    if (!answerData.eventValue) return <Typography>参照できません</Typography>;
    else
      return (
        <DialogContentText>
          <Typography variant="body1">Affect Grid</Typography>
          <Typography variant="body2">
            arousal:{answerData.affectGrid.arousal}, pleasantness:
            {answerData.affectGrid.pleasantness}
          </Typography>
          <Typography variant="body1">出来事の価値</Typography>
          <Typography variant="body2">{answerData.eventValue}</Typography>
          <Typography variant="body1">出来事の質</Typography>
          <Typography variant="body2">
            Controllable: {answerData.eventControllable.toString()}
          </Typography>
          <Typography variant="body2">
            Relationship: {answerData.eventRelation.toString()}
          </Typography>
        </DialogContentText>
      );
  };

  const postDataView = (answerData: postDairyAnswerDataType | null) => {
    if (!answerData) return <Typography>未回答</Typography>;
    else
      return (
        <DialogContentText>
          <Typography variant="body1">Affect Grid</Typography>
          <Typography variant="body2">
            arousal:{answerData.affectGrid.arousal}, pleasantness:
            {answerData.affectGrid.pleasantness}
          </Typography>
          <Typography variant="body1">出来事の価値</Typography>
          <Typography variant="body2">{answerData.eventValue}</Typography>
          <Typography variant="body1">チャットの評価</Typography>
          <Typography variant="body2">
            満足度：{answerData.satisfactionValue}
          </Typography>
          <Typography variant="body2">
            新奇性：{answerData.noveltyValue}
          </Typography>
        </DialogContentText>
      );
  };

  return (
    <Dialog open={isOn}>
      <DialogTitle>{date}のアンケート回答</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography variant="caption">
            開発時のデバッグ用として回答結果を確認できるようにしました
          </Typography>
        </DialogContentText>
        <Box sx={{ height: "1rem" }} />
        <DialogContentText>チャット前</DialogContentText>
        {preDataView(preAnswer)}
        <Box sx={{ height: "1rem" }} />
        <DialogContentText>チャット後</DialogContentText>
        {postDataView(postAnswer)}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={() => setIsOn(false)}>
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
};
